@if (openIndexes | fn: getOpenIndexIds : instanceId; as openIndexIds) {
    <div
        ngbAccordion
        #accordion="ngbAccordion"
        class="accordion"
        [class.accordion-flush]="flush"
        [ngClass]="customAccordionClass"
        [closeOthers]="closeOthers"
        [destroyOnHide]="destroyOnHide"
        (hide)="onPanelChange($event, true)"
        (show)="onPanelChange($event, false)"
    >
        @for (
            panel of panels;
            track $index;
            let first = $first;
            let i = $index
        ) {
            @if (i | fn: getPanelId : instanceId : panelIds; as panelId) {
                <div
                    [ngbAccordionItem]="panelId"
                    [ngClass]="
                        accordion.isExpanded(panelId)
                            | fn
                                : setCardClass
                                : highlightOpenPanels
                                : customCardClass
                    "
                    [collapsed]="!openIndexIds.includes(panelId)"
                    [disabled]="panel.isDisabled || disabled"
                >
                    <div ngbAccordionHeader>
                        <button
                            ngbAccordionButton
                            class="accordion-header accordion-button"
                            [class.disabled]="panel.isDisabled || disabled"
                            (click)="onPanelToggleClicked(panel)"
                        >
                            @if (panel.guidanceText) {
                                <wdx-icon
                                    class="guidance-icon text-muted pointer"
                                    icon="question-circle"
                                    scale="1"
                                    container="body"
                                    popoverClass="popover-info"
                                    [ngbPopover]="panel.guidanceText"
                                    (click)="$event.stopPropagation()"
                                ></wdx-icon>
                            }
                            @if (panel.icon) {
                                <wdx-icon
                                    class="me-2 flex-shrink-0 icon-shift-up"
                                    [ngClass]="panel.severity"
                                    [icon]="panel.icon"
                                ></wdx-icon>
                            }
                            @if (panel.label || panel.contact) {
                                <div
                                    class="accordion-header__content flex-grow-1 d-flex flex-column flex-xl-row"
                                >
                                    <div>
                                        {{ panel.label }}
                                    </div>
                                    @if (panel.contact?.name) {
                                        <div class="ms-0 ms-xl-2">
                                            <a
                                                [routerLink]="
                                                    panel.contact.routerLink
                                                "
                                                >{{ panel.contact.name }}</a
                                            >
                                        </div>
                                    }
                                </div>
                            }
                            @if (!panel.headerTemplate) {
                                <div
                                    class="d-flex flex-column-reverse flex-xl-row"
                                >
                                    <div
                                        class="d-flex align-items-center justify-content-end flex-nowrap"
                                    >
                                        <div class="ms-1 ms-xl-2">
                                            <div class="d-none d-xl-block">
                                                @if (panel.avatars) {
                                                    <molecule-avatar-group
                                                        size="sm"
                                                        [avatars]="
                                                            panel.avatars
                                                        "
                                                    ></molecule-avatar-group>
                                                }
                                            </div>
                                            <div class="d-block d-xl-none">
                                                @if (panel.avatars) {
                                                    <molecule-avatar-group
                                                        size="xs"
                                                        [avatars]="
                                                            panel.avatars
                                                        "
                                                    ></molecule-avatar-group>
                                                }
                                            </div>
                                        </div>
                                        @if (panel.comments) {
                                            <atom-comment-status
                                                class="ms-1 ms-xl-2"
                                                [commentStatus]="panel.comments"
                                            ></atom-comment-status>
                                        }
                                    </div>
                                    @if (panel.detail !== undefined) {
                                        <div
                                            class="accordion-header__detail ms-l ms-xl-2"
                                            [ngClass]="
                                                panel
                                                    | fn: getStatusSeverityClass
                                            "
                                        >
                                            {{ panel.detail }}
                                        </div>
                                    }
                                </div>
                            }
                            <ng-container
                                *ngTemplateOutlet="
                                    panel.headerTemplate;
                                    context: { data: panel.headerData }
                                "
                            ></ng-container>
                        </button>
                    </div>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-container
                                *ngTemplateOutlet="
                                    panel.template;
                                    context: { data: panel.templateData }
                                "
                            ></ng-container>
                        </div>
                    </div>
                </div>
            }
        }
    </div>
}
